import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.scss?vue&type=style&index=0&id=2d2b2dd2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2b2dd2"]])

export default __exports__